import React, { createContext, Dispatch, ReactNode, SetStateAction, useContext, useEffect, useState } from 'react';
import { PurchaseOrder, PurchaseOrderMember } from '@/hooks/api/models';

type Props = {
  children: ReactNode;
};

export type PurchaseOrderContextType = {
  _po_?: PurchaseOrder;
  set_po_: Dispatch<SetStateAction<PurchaseOrder | undefined>>;
  mePurchaseOrderMember?: PurchaseOrderMember;
  setMePurchaseOrderMember: Dispatch<SetStateAction<PurchaseOrderMember | undefined>>;
};

export const PurchaseOrderContext = createContext<PurchaseOrderContextType>({
  _po_: undefined,
  set_po_: () => {},
  mePurchaseOrderMember: undefined,
  setMePurchaseOrderMember: () => {},
});

export const PurchaseOrderProvider = ({ children }: Props) => {
  const [_po_, set_po_] = useState<PurchaseOrder>();
  const [purchaseOrder, setPurchaseOrder] = useState<PurchaseOrder>();
  const [mePurchaseOrderMember, setMePurchaseOrderMember] = useState<PurchaseOrderMember>();

  return (
    <PurchaseOrderContext.Provider value={{ _po_, set_po_, mePurchaseOrderMember, setMePurchaseOrderMember }}>
      {children}
    </PurchaseOrderContext.Provider>
  );
};

export const useCurrentPurchaseOrder = () => {
  return useContext(PurchaseOrderContext);
};
